import { useNavigation, useRoute } from '@react-navigation/core';
import React from 'react';
import { SafeAreaView, ScrollView, StyleSheet } from 'react-native';
import { Modals } from '../../../constants/ScreenNames';
import { CommonProperties, CommonStyles } from '../../../styles';
import Button from '../../Button';
import MainSettingsWidget from '../../TripEvents/MainSettingsWidget';
import AirSettingsWidget from '../../TripEvents/AirSettingsWidget';
import HotelSettingsWidget from '../../TripEvents/HotelSettingsWidget';

const TravelSettingsModal = () => {
  const navigation = useNavigation();
  const route = useRoute();
  const { event } = route?.params || {};

  return (
    <SafeAreaView style={styles.safeContainer}>
      <ScrollView style={CommonStyles.p4}>
        <MainSettingsWidget style={CommonStyles.mb3} />
        {event?.isAir ? <AirSettingsWidget style={CommonStyles.mb3} /> : null}
        {event?.isHotel ? <HotelSettingsWidget /> : null}
        <Button
          style={styles.submitButton}
          label="Apply"
          labelStyle={CommonStyles.h2}
          onPress={() => navigation.navigate(Modals.EventSettingsModal, { event })}
        />
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  safeContainer: {
    flex: 1,
    backgroundColor: 'white',
  },
  submitButton: {
    ...CommonProperties.mt5,
    ...CommonProperties.py3,
    ...CommonProperties.shadow,
    ...CommonProperties.borderRadius4,
  },
});

export default TravelSettingsModal;
